<template style="width: 100px;">
  <div class="MessageCenter">
    <div class="MessageCenterHeard">
      <div class="title">
        <a v-if="!choice" @click="choiceTrue">返回</a>
        <a v-else style="width: 28px;"></a>
        {{ msgBasicName }}
        <a v-if="choice" @click="close">关闭</a>
        <a v-else @click="infoClick">详情</a>
      </div>
    </div>

    <ul v-show="choice" class="MessageTopicList">
      <Scroll style="width: 100%;">
        <li class="MessageTopicItem" v-for="(item,index) in subscribeList" :key="index"
            @click="importantChoice(item)">
          <img src="@/assets/images/default.png" alt="" class="MessageTopicImage">
          <div class="MessageTopicContent">
            <div class="MessageTopicName"><a>{{ item.msgBasicName }}</a></div>
            <div class="MessageTopicTime"><a>{{formatChatTime(item.messageSourceSendTime )}}</a></div>
            <div class="MessageTopicBriefly"><a>{{ item.messageBriefing }}</a></div>
            <div v-if="item.unreadTotal" class="MessageTopicUnread"><a>{{ item.unreadTotal }}</a></div>
          </div>
        </li>
        <div style="width: 90%;margin: 5%;display: flex;justify-content: center;align-items: center">没有更多了</div>
      </Scroll>
    </ul>

    <m-chat v-show="!choice" ref="mChat" :messages="tempMessages"
            @submit="submit"
            :loadMore="loadMore"
            :comment="true"
            height="calc(100vh - 64px) "
            :customRecord="false"
            :openExtends="['image']"
            :openBases = "['text','emoji']"
            :config="config">
    </m-chat>

<!--    <div class="MessageToTopicDetail">-->
<!--    </div>-->
  </div>
</template>

<script>

// 群组消息配置
import Vue from 'vue';
import Axios from 'axios'
import setting from '@/setting'
import MChat from '@maybecode/m-chat'
import {mapState} from 'vuex';
import costTable from "@/pages/BusinessReportV0/1InterTripExpenseEntry/cost";

export default {
  name: "MessageCenter",
  computed: {
    ...mapState('admin/user', [
      'info'
    ]),
  },
  components: {
    MChat,
  },
  data() {
    return {
      choice: true,
      fastInput: true,
      config: {
        theme: 'light',
        file: {
          accept: ['*'],
        }
      },
      msgBasicName: "好友列表",
      messageTargetTopicId: "",
      messageSendTime: "",
      subscribeList: [],
      tempMessages: [],
      messages: new Map(),
      ws:null,
      tempPage:0,
    }
  },
  methods: {
    /* 获取消息中心消息列表 */
    querySubscribeList(){
      let that = this
      //初始化订阅列表
      Axios.get(`${setting.messageCenterUrl}/v0/msg/center/topic/subscribe/${this.info.id}`)
          .then(response => {
            let rd = response.data
            that.subscribeList = rd.data
          })
    },
    /* 发送消息 */
    submit(data) {
      let sendMsg = {
        messageSourceUserId: this.info.id,
        messageSourceUserPhoto: this.info.avatar,
        messageSourceUserName: this.info.name,
        messageTargetTopicId: this.messageTargetTopicId,
        messageSubject: data.content,
        messageType: data.type,
        pushScheme: "websocket"
      }
      console.log( 'sendMsg:',sendMsg )
      Axios.post(`${setting.messageCenterUrl}/v0/msg/center/topic/message`, sendMsg)
    },
    /* 加载更多 */
    loadMore() {

      console.log("获取聊天记录")

      let that = this
      that.tempMessages = null;
      if (that.messages.has(that.messageTargetTopicId)) {
        that.messageSendTime = that.messages.get(that.messageTargetTopicId)[0].messageSourceSendTime
      } else {
        this.messages.set(that.messageTargetTopicId, [])
      }
      Axios.post(`${setting.messageCenterUrl}/v0/msg/center/topic/${that.messageTargetTopicId}/message`, {
        messageSourceSendTime: that.messageSendTime,
        sortOrder: true,
        offset: 0,
        limit: 10
      }).then(response => {
        let records = response.data.data.records
        records.forEach(s => this.addMessage(s, false))
      })
    },
    /* 打开聊天窗口并清空未读消息 */
    importantChoice(item) {
      Axios.get(`${setting.messageCenterUrl}/v0/msg/center/clear_unread/${item.messageTopicId}/${this.info.id}`)
      this.messageTargetTopicId = item.messageTopicId
      this.messages.delete(item.messageTopicId)
      /* 打开窗口加载 */
      this.loadMore()
      this.msgBasicName = item.msgBasicName
      this.choice = false
    },
    /* 返回好友列表 */
    choiceTrue() {
      let that = this
      that.msgBasicName = "好友列表"
      that.choice = true
      /* 每次返回的时候更新列表 */
      that.querySubscribeList()
    },
    /* 关闭聊天窗口 */
    close() {
      console.log("关闭当前窗口")
      window.parent.postMessage("close", '*')
       // this.$emit('close-message-center')
    },
    /* 链接消息中心 */
    websocketOnOpen() {
      console.log("WebSocket连接成功");
      // 添加心跳检测，每30秒发一次数据，防止连接断开（这跟服务器的设置有关，如果服务器没有设置每隔多长时间不发消息断开，可以不进行心跳设置）
      let self = this;
      self.ws.send(this.info.id)
    },
    //接收后端返回的数据，可以根据需要进行处理
    websocketOnMessage(res) {

      console.log('res:',res)
      let msg = JSON.parse(res.data)
      console.log(msg)
      /* 判断消息类型 */
      if(msg.messageType === 'open' && msg.messageSubject === this.info.id){
        /* 切换到聊天窗口 */
        this.messageTargetTopicId = msg.messageTargetTopicId
        /* 打开窗口加载 */
        this.messages.delete(msg.messageTargetTopicId)
        this.loadMore()
        this.msgBasicName = "在线联系"
        this.choice = false
        window.parent.postMessage("open", '*')
        return false;
      }
      this.addMessage(msg, true)
    },

    /* 添加消息 */
    addMessage(data, direction) {
      let message = {
        id: data.id,
        name: data.messageSourceUserName,
        content: {
          text: data.messageSubject,
        },
        type: data.messageType,
        self: this.info.id === data.messageSourceUserId,
        avatar: data.messageSourceUserPhoto,
        messageSourceSendTime: data.messageSourceSendTime
      }
      if (this.fastInput) {
        this.fastInput = false;
        message.time = data.messageSourceSendTime
      }
      if (data.msgType === "image") {
        message.content = {
          imageUrl: "/agile-bpm-platform" + data.msgContent,
        }
      }
      if (data.msgType === "video") {
        message.content = {
          videoUrl: "/agile-bpm-platform" + data.msgContent,
        }
      }
      if (data.msgType === "audio") {
        message.content = {
          audioUrl: "/agile-bpm-platform" + data.msgContent,
        }
      }
      if (data.msgType === "file") {
        message.content = {
          fileUrl: "/agile-bpm-platform" + data.msgContent,
        }
      }

      direction ? this.messages.get(data.messageTargetTopicId).push(message) : this.messages.get(data.messageTargetTopicId).unshift(message);
      //对应内容装载到临时储存空间
      this.tempMessages = this.messages.get(data.messageTargetTopicId)
    },
    formatChatTime(time) {
      if(time === ""){
        return "";
      }
      time = this.dateFormat("YY-mm-dd HH:MM:SS", new Date(time));
      var date = time.toString();
      var year = date.split("-")[0];
      var month = date.split("-")[1];
      var day = date.split("-")[2];
      var d1 = new Date(year + '/' + month + '/' + day.split(" ")[0]);
      var d3 = new Date(date.replace(/-/g, "/"));
      var dd = new Date();
      var y = dd.getFullYear();
      var m = dd.getMonth() + 1;
      var d = dd.getDate();
      var d2 = new Date(y + '/' + m + '/' + d);
      var iday = parseInt(d2 - d1) / 1000 / 60 / 60 / 24;
      var hours = d3.getHours();
      var minutes = d3.getMinutes();
      if (minutes < 10) {
        minutes = '0' + minutes;
      }
      if (hours < 10) {
        hours = '0' + hours;
      }
      if (iday == 0) {
        if (hours >= 12) {
          return "下午 " + hours + ":" + minutes;
        } else {
          return "上午 " + hours + ":" + minutes;;
        }
      } else if (iday == 1) {
        var dt = "";
        if (hours >= 12) {
          dt = "下午 " + hours + ":" + minutes;
        } else {
          dt = "上午 " + hours + ":" + minutes;;
        }
        return "昨天 " + dt;
      } else if (iday == 2) {
        var dt = "";
        if (hours >= 12) {
          dt = "下午 " + hours + ":" + minutes;
        } else {
          dt = "上午 " + hours + ":" + minutes;;
        }
        return "前天 " + dt;
      } else {
        return year + '/' + month + "/" + d1.getDate()
      }
    },
    dateFormat(fmt, date) {
      let ret;
      const opt = {
        "Y+": date.getFullYear().toString(), // 年
        "m+": (date.getMonth() + 1).toString(), // 月
        "d+": date.getDate().toString(), // 日
        "H+": date.getHours().toString(), // 时
        "M+": date.getMinutes().toString(), // 分
        "S+": date.getSeconds().toString() // 秒
      };
      for (let k in opt) {
        ret = new RegExp("(" + k + ")").exec(fmt);
        if (ret) {
          fmt = fmt.replace(ret[1], (ret[1].length == 1) ? (opt[k]) : (opt[k].padStart(ret[1].length, "0")))
        };
      };
      return fmt;
    },

    infoClick(){
      console.log('详情点击事件')

      let that = this
      /* 通过接口获取详情列表 */
      Axios.get(`${setting.messageCenterUrl}/v0/msg/center/user_list/${that.messageTargetTopicId}`).then(msgRes =>{
         console.log( 'msgRes:',msgRes )
        let rd = msgRes.data
        let d = {
          queryData: [{
            name: "org_user.id_",
            con: "in",
            val: rd.data
          }]
        }
        this.abHttpUtil.post(`/form/formCustSql/view/list_orgUserList`,
            d).then(res => {
          console.log( 'res',res )
        })
      })
    }
  },
  created() {
    this.querySubscribeList()
    let url = `ws://106.15.59.231:9997/ws`
    this.ws = new WebSocket(url);
    this.ws.onopen = this.websocketOnOpen;
    this.ws.onmessage = this.websocketOnMessage;

  },
}
</script>

<style scoped>

/deep/ .ivu-scroll-container {
  min-height: calc(100vh - 64px);
}

/deep/ .my-icon-yuyin {
  display: contents;
}

a {
  color: #999999;
}

.MessageCenterHeard {
  width: 100%;
  height: 64px;
  background: linear-gradient(to right, #1d42ab, #2173dc, #1e93ff);
  display: flex;
  flex-wrap: wrap;
}

.title {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: #FFFFFF;
  padding: 0 5% 0 5%;
}

.info {
  width: 100%;
  display: flex;
  align-items: center;

  color: #FFFFFF;
  padding: 0 5% 0 5%;
}

.MessageCenterHeard a {
  color: #FFFFFF;
}

.MessageTopicList {
  width: 100%;
  display: flex;
  font-size: 14px;
  flex-wrap: wrap;
  background-color: #f2f2f2;
  height: 500px;
}

.MessageTopicItem {
  display: flex;
  width: 90%;
  margin: 0 5% 0 5%;
  border-bottom: 1px solid #ebebeb;
}

.MessageTopicImage {
  margin-top: 0.4rem;
  display: flex;
  width: 15%;
  margin-bottom: 0.4rem;
  border-radius: 5px;
}

.MessageTopicContent {
  /*padding: 10px 20px 10px 20px ;*/
  margin-top: 0.4rem;
  margin-left: 20px;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  margin-right: 0.5rem;
  width: 85%;
}

.MessageTopicName {
  display: flex;
  width: 70%;
  font-size: 14px;
}

.MessageTopicTime {
  display: flex;
  width: 30%;
  font-size: 10px;
  justify-content: flex-end;
  align-items: center;
  color: #999999;
}

.MessageTopicBriefly {
  display: flex;
  font-size: 10px;
  width: 90%;
  color: #999999;
  align-items: center;
  margin-bottom: 10px;
}

.MessageTopicUnread {
  display: flex;
  background-color: red;
  border-radius: 15px;
  width: 21px;
  height: 18px;
  font-size: 10px;
  justify-content: center;
  align-items: center;
  color: #FFFFFF;
  margin-bottom: 10px;
  /*padding: 0 3px 0 3px;*/
}

.MessageTopicUnread a {
  color: #FFFFFF;
}

.MessageToTopicDetail {
  height: 300px;
}

</style>
